// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/form.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/form.proto.
 */
export const file_api_proto_v1_form: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message api_proto.v1.FormGroup
 */
export type FormGroup = Message<"api_proto.v1.FormGroup"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated api_proto.v1.Form forms = 3;
   */
  forms: Form[];
};

/**
 * Describes the message api_proto.v1.FormGroup.
 * Use `create(FormGroupSchema)` to create a new message.
 */
export const FormGroupSchema: GenMessage<FormGroup> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 0);

/**
 * @generated from message api_proto.v1.CopyFrom
 */
export type CopyFrom = Message<"api_proto.v1.CopyFrom"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: api_proto.v1.InformationType type = 2;
   */
  type: InformationType;
};

/**
 * Describes the message api_proto.v1.CopyFrom.
 * Use `create(CopyFromSchema)` to create a new message.
 */
export const CopyFromSchema: GenMessage<CopyFrom> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 1);

/**
 * @generated from message api_proto.v1.Form
 */
export type Form = Message<"api_proto.v1.Form"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: api_proto.v1.FormType form_type = 3;
   */
  formType: FormType;

  /**
   * @generated from field: optional api_proto.v1.MoneyType money_type = 4;
   */
  moneyType?: MoneyType;

  /**
   * @generated from field: string placeholder = 10;
   */
  placeholder: string;

  /**
   * @generated from field: bool required = 11;
   */
  required: boolean;

  /**
   * @generated from field: bool readonly = 12;
   */
  readonly: boolean;

  /**
   * @generated from field: string suffix = 13;
   */
  suffix: string;

  /**
   * @generated from field: repeated api_proto.v1.SelectOption select_options = 14;
   */
  selectOptions: SelectOption[];

  /**
   * @generated from field: optional string parent_deal_default_form_name = 15;
   */
  parentDealDefaultFormName?: string;

  /**
   * @generated from field: repeated api_proto.v1.Form child_forms = 16;
   */
  childForms: Form[];

  /**
   * @generated from field: string default_value = 17;
   */
  defaultValue: string;

  /**
   * @generated from field: bool future = 18;
   */
  future: boolean;

  /**
   * @generated from field: int64 min_length = 19;
   */
  minLength: bigint;

  /**
   * @generated from field: int64 max_length = 20;
   */
  maxLength: bigint;

  /**
   * @generated from field: optional api_proto.v1.CopyFrom copy_from = 21;
   */
  copyFrom?: CopyFrom;

  /**
   * @generated from field: bool show_force = 22;
   */
  showForce: boolean;

  /**
   * @generated from field: bool to_b_hidden = 23;
   */
  toBHidden: boolean;

  /**
   * @generated from field: bool to_c_hidden = 24;
   */
  toCHidden: boolean;

  /**
   * 自動計算などで表示するので、フォームでは表示しない
   *
   * @generated from field: bool form_hidden = 25;
   */
  formHidden: boolean;
};

/**
 * Describes the message api_proto.v1.Form.
 * Use `create(FormSchema)` to create a new message.
 */
export const FormSchema: GenMessage<Form> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 2);

/**
 * FORM_TYPE_TEXT_SUGGESTのサジェストでも使用する
 *
 * @generated from message api_proto.v1.SelectOption
 */
export type SelectOption = Message<"api_proto.v1.SelectOption"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 選択不可の選択肢。既存レコードの現在値（例: 停止済みのスタッフが担当者のまま）を表示・保持するために
   * 候補へ含めるが、新規に選ばせない。true のときフロントは選択UIで無効化して表示する（決定90(m)）。
   *
   * @generated from field: bool disabled = 3;
   */
  disabled: boolean;
};

/**
 * Describes the message api_proto.v1.SelectOption.
 * Use `create(SelectOptionSchema)` to create a new message.
 */
export const SelectOptionSchema: GenMessage<SelectOption> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 3);

/**
 * @generated from message api_proto.v1.RepeatdString
 */
export type RepeatdString = Message<"api_proto.v1.RepeatdString"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message api_proto.v1.RepeatdString.
 * Use `create(RepeatdStringSchema)` to create a new message.
 */
export const RepeatdStringSchema: GenMessage<RepeatdString> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 4);

/**
 * @generated from message api_proto.v1.FormRequest
 */
export type FormRequest = Message<"api_proto.v1.FormRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from oneof api_proto.v1.FormRequest.value
   */
  value: {
    /**
     * @generated from field: string string = 2;
     */
    value: string;
    case: "string";
  } | {
    /**
     * @generated from field: double number = 3;
     */
    value: number;
    case: "number";
  } | {
    /**
     * @generated from field: google.protobuf.Timestamp date = 4;
     */
    value: Timestamp;
    case: "date";
  } | {
    /**
     * @generated from field: api_proto.v1.RepeatdString repeated_values = 5;
     */
    value: RepeatdString;
    case: "repeatedValues";
  } | {
    /**
     * @generated from field: bool boolean = 6;
     */
    value: boolean;
    case: "boolean";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api_proto.v1.FormRequest.
 * Use `create(FormRequestSchema)` to create a new message.
 */
export const FormRequestSchema: GenMessage<FormRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 5);

/**
 * @generated from message api_proto.v1.FormValue
 */
export type FormValue = Message<"api_proto.v1.FormValue"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 form_id = 2;
   */
  formId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from oneof api_proto.v1.FormValue.value
   */
  value: {
    /**
     * @generated from field: string string = 4;
     */
    value: string;
    case: "string";
  } | {
    /**
     * @generated from field: double number = 5;
     */
    value: number;
    case: "number";
  } | {
    /**
     * @generated from field: google.protobuf.Timestamp date = 6;
     */
    value: Timestamp;
    case: "date";
  } | {
    /**
     * @generated from field: api_proto.v1.RepeatdString repeated_values = 7;
     */
    value: RepeatdString;
    case: "repeatedValues";
  } | {
    /**
     * @generated from field: bool boolean = 8;
     */
    value: boolean;
    case: "boolean";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional api_proto.v1.Form form = 9;
   */
  form?: Form;
};

/**
 * Describes the message api_proto.v1.FormValue.
 * Use `create(FormValueSchema)` to create a new message.
 */
export const FormValueSchema: GenMessage<FormValue> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_form, 6);

/**
 * @generated from enum api_proto.v1.InformationType
 */
export enum InformationType {
  /**
   * @generated from enum value: INFORMATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INFORMATION_TYPE_DEAL = 1;
   */
  DEAL = 1,

  /**
   * @generated from enum value: INFORMATION_TYPE_CUSTOMER = 2;
   */
  CUSTOMER = 2,
}

/**
 * Describes the enum api_proto.v1.InformationType.
 */
export const InformationTypeSchema: GenEnum<InformationType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_form, 0);

/**
 * @generated from enum api_proto.v1.FormType
 */
export enum FormType {
  /**
   * @generated from enum value: FORM_TYPE_TEXT_UNSPECIFIED = 0;
   */
  TEXT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORM_TYPE_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: FORM_TYPE_SELECT = 2;
   */
  SELECT = 2,

  /**
   * @generated from enum value: FORM_TYPE_CHECKBOX = 3;
   */
  CHECKBOX = 3,

  /**
   * @generated from enum value: FORM_TYPE_TEL = 4;
   */
  TEL = 4,

  /**
   * @generated from enum value: FORM_TYPE_NUMBER = 5;
   */
  NUMBER = 5,

  /**
   * @generated from enum value: FORM_TYPE_DATE = 6;
   */
  DATE = 6,

  /**
   * @generated from enum value: FORM_TYPE_TEXTAREA = 7;
   */
  TEXTAREA = 7,

  /**
   * @generated from enum value: FORM_TYPE_FILE = 8;
   */
  FILE = 8,

  /**
   * @generated from enum value: FORM_TYPE_FILE_MULTIPLE = 9;
   */
  FILE_MULTIPLE = 9,

  /**
   * @generated from enum value: FORM_TYPE_IMAGE = 10;
   */
  IMAGE = 10,

  /**
   * @generated from enum value: FORM_TYPE_IMAGE_MULTIPLE = 11;
   */
  IMAGE_MULTIPLE = 11,

  /**
   * @generated from enum value: FORM_TYPE_TEXT_SUGGEST = 12;
   */
  TEXT_SUGGEST = 12,

  /**
   * 独自の計算ロジックを持つフォームタイプ
   *
   * @generated from enum value: FORM_TYPE_TAX = 13;
   */
  TAX = 13,

  /**
   * @generated from enum value: FORM_TYPE_GROSS_PROFIT = 14;
   */
  GROSS_PROFIT = 14,

  /**
   * @generated from enum value: FORM_TYPE_GROSS_PROFIT_RATE = 15;
   */
  GROSS_PROFIT_RATE = 15,

  /**
   * @generated from enum value: FORM_TYPE_MONEY = 16;
   */
  MONEY = 16,

  /**
   * 使っていない
   *
   * @generated from enum value: FORM_TYPE_ADDITIONAL_GROSS_PROFIT = 17 [deprecated = true];
   * @deprecated
   */
  ADDITIONAL_GROSS_PROFIT = 17,

  /**
   * @generated from enum value: FORM_TYPE_ADDITIONAL_GROSS_PROFIT_RATE = 18 [deprecated = true];
   * @deprecated
   */
  ADDITIONAL_GROSS_PROFIT_RATE = 18,

  /**
   * HTML形式とは別のカスタムタイプ
   *
   * @generated from enum value: FORM_TYPE_CUSTOMER = 19;
   */
  CUSTOMER = 19,

  /**
   * @generated from enum value: FORM_TYPE_COMPANY_STAFF = 20;
   */
  COMPANY_STAFF = 20,

  /**
   * @generated from enum value: FORM_TYPE_ZIP_CODE = 21;
   */
  ZIP_CODE = 21,

  /**
   * @generated from enum value: FORM_TYPE_PREFECTURE = 22;
   */
  PREFECTURE = 22,

  /**
   * @generated from enum value: FORM_TYPE_CITY = 23;
   */
  CITY = 23,

  /**
   * @generated from enum value: FORM_TYPE_STREET = 24;
   */
  STREET = 24,

  /**
   * addressのgroup可のため
   *
   * @generated from enum value: FORM_TYPE_ADDRESS = 26;
   */
  ADDRESS = 26,

  /**
   * @generated from enum value: FORM_TYPE_CUSTOMER_TYPE = 27;
   */
  CUSTOMER_TYPE = 27,

  /**
   * @generated from enum value: FORM_TYPE_OLD_IESAPURI_CSV = 28;
   */
  OLD_IESAPURI_CSV = 28,

  /**
   * @generated from enum value: FORM_TYPE_GROUP = 29;
   */
  GROUP = 29,

  /**
   * @generated from enum value: FORM_TYPE_SELECT_MULTIPLE = 30;
   */
  SELECT_MULTIPLE = 30,

  /**
   * 独自の計算ロジックを持つフォームタイプ
   * idを変えなくないので、ブロックがおかしい
   *
   * @generated from enum value: FORM_TYPE_MONEY_GROUP = 31;
   */
  MONEY_GROUP = 31,

  /**
   * @generated from enum value: FORM_TYPE_MONEY_GROUP_CONTRACT = 32;
   */
  MONEY_GROUP_CONTRACT = 32,

  /**
   * @generated from enum value: FORM_TYPE_MONEY_GROUP_COMPLETE = 33;
   */
  MONEY_GROUP_COMPLETE = 33,

  /**
   * @generated from enum value: FORM_TYPE_MONEY_GROUP_ADDITIONAL = 34;
   */
  MONEY_GROUP_ADDITIONAL = 34,

  /**
   * @generated from enum value: FORM_TYPE_SALES = 36;
   */
  SALES = 36,

  /**
   * @generated from enum value: FORM_TYPE_COST = 37;
   */
  COST = 37,

  /**
   * @generated from enum value: FORM_TYPE_COST_DETAIL = 38;
   */
  COST_DETAIL = 38,

  /**
   * HTML形式とは別のカスタムタイプ
   *
   * @generated from enum value: FORM_TYPE_EXTERNAL_CSV = 39;
   */
  EXTERNAL_CSV = 39,

  /**
   * 仮想フィールド（表示専用）
   *
   * @generated from enum value: FORM_TYPE_VIRTUAL_LATEST_MEMO = 50;
   */
  VIRTUAL_LATEST_MEMO = 50,
}

/**
 * Describes the enum api_proto.v1.FormType.
 */
export const FormTypeSchema: GenEnum<FormType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_form, 1);

/**
 * @generated from enum api_proto.v1.MoneyType
 */
export enum MoneyType {
  /**
   * @generated from enum value: MONEY_TYPE_PLUS_UNSPECIFIED = 0;
   */
  PLUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MONEY_TYPE_MINUS = 1;
   */
  MINUS = 1,
}

/**
 * Describes the enum api_proto.v1.MoneyType.
 */
export const MoneyTypeSchema: GenEnum<MoneyType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_form, 2);

/**
 * @generated from enum api_proto.v1.CustomerType
 */
export enum CustomerType {
  /**
   * @generated from enum value: CUSTOMER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOMER_TYPE_TO_C = 1;
   */
  TO_C = 1,

  /**
   * @generated from enum value: CUSTOMER_TYPE_TO_B = 2;
   */
  TO_B = 2,

  /**
   * @generated from enum value: CUSTOMER_TYPE_OTHER = 3;
   */
  OTHER = 3,
}

/**
 * Describes the enum api_proto.v1.CustomerType.
 */
export const CustomerTypeSchema: GenEnum<CustomerType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_form, 3);

